module.exports = __webpack_public_path__ + "img/pulldown_icon.01edf0b0.png";